import { FONT, COLORS } from "../../styles";

export default function AlertBanner({ level, msg }) {
  const isCritical = level === "CRITICAL";
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "12px 16px", background: isCritical ? COLORS.redLight : COLORS.orangeLight, border: `1px solid ${isCritical ? "#FECACA" : "#FDE68A"}`, borderRadius: 8, marginBottom: 8 }}>
      <span style={{ fontSize: 11, padding: "2px 8px", background: isCritical ? "#FCA5A5" : "#FCD34D", color: isCritical ? "#991B1B" : "#92400E", fontFamily: FONT, fontWeight: 600, borderRadius: 4, flexShrink: 0, marginTop: 1 }}>{level}</span>
      <span style={{ fontSize: 13, color: isCritical ? "#991B1B" : "#92400E", fontFamily: FONT, lineHeight: 1.5 }}>{msg}</span>
    </div>
  );
}
